/**
 * NotificationBar class to handle the display and behavior of the notification bar.
 *
 * This class adjusts the notification bar on page load and resize,
 * and handles the close button functionality with cookie support.
 */
export const NotificationBar = function() {
    !function() {
        // Call function on page load
        adjust_bar();

        jQuery(window).on('resize', adjust_bar);

        jQuery('body').on('click', '.polybar .close-btn', close_bar);
    }();

    /**
     * Closes the notification bar.
     *
     * @param {Event} event The click event.
     */
    function close_bar(event) {
        event.preventDefault();
        jQuery('.polybar').toggle();

        // Set cookie to expire 1 day later
        Cookies.set('polybar', 1, { expires: 1 });
        adjust_bar();
    }

    /**
     * Adjusts the notification bar based on its presence and cookie status.
     */
    function adjust_bar() {
        if (jQuery('.polybar').length) {
            jQuery('body').addClass('notification-bar');
            jQuery('#notification-bar').show();
        } else {
            jQuery('body').removeClass('notification-bar');
            jQuery('#notification-bar').hide();
        }

        // Get polybar cookie
        const polybar_cookie = Cookies.get('polybar');

        if (!polybar_cookie) {
            jQuery('.polybar').show();
        } else {
            jQuery('#notification-bar').css('height', '0');
            jQuery('.polybar').hide();
        }
    }
};